// extracted by mini-css-extract-plugin
module.exports = {"chart_start_color":"#072B2C","gray_color":"#c2c2c2","main_color":"#ced1c2","success_color":"#3fd184","error_color":"#ff6e6e","modal_background":"#333333"};